import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from 'app/App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import {
  ThemeProvider,
  getStoredThemePreference,
  resolveThemePreference,
} from 'app/providers/ThemeContext';
// import awsExports from './aws-exports';
// Amplify.configure(awsExports);

const root = ReactDOM.createRoot(document.getElementById('root'));
const initialThemePreference = getStoredThemePreference();
const initialTheme = resolveThemePreference(
  initialThemePreference,
  window.matchMedia('(prefers-color-scheme: dark)').matches
);

document.documentElement.setAttribute('data-theme', initialTheme);
document.documentElement.setAttribute('data-theme-preference', initialThemePreference);
document.documentElement.setAttribute('data-bs-theme', initialTheme);

root.render(
  <React.StrictMode>
    <ThemeProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
